import React from 'react'
import { Skeleton } from 'antd'
import TeamEnergyContentSkeleton from './TeamEnergyContentSkeleton'

const TeamEnergyPageSkeleton: React.FC = () => {
  return (
    <div className="main-content team-energy-page">
      <div className="te-header">
        <div className="te-header__intro">
          <Skeleton.Input active size="default" style={{ width: 180, height: 28 }} />
          <Skeleton.Input active size="small" style={{ width: 200, height: 14 }} />
        </div>
        <div className="te-header__selector">
          <Skeleton.Input active size="small" style={{ width: 80, height: 16 }} />
          <Skeleton.Input active style={{ width: 280, height: 32 }} />
        </div>
      </div>
      <TeamEnergyContentSkeleton />
    </div>
  )
}

export default TeamEnergyPageSkeleton
